import {createSvgIcon} from '../create-svg-icon';

export const HorizontalSplitIcon = createSvgIcon(
  <path d="M19 15v2H5v-2h14m2-10H3v2h18V5zm0 4H3v2h18V9zm0 4H3v6h18v-6z" />
, 'HorizontalSplitOutlined');
